module.exports = __webpack_public_path__ + "static/media/whatsapp_icon_151518.8176aeae.svg";